import { JobseekerFile } from './jobseeker-file';
import { JobseekerWorkExperienceCategoryModel } from './jobseeker-work-experience-category';
import { Serializable } from '../../../core/models/serializable';

export class JobseekerWorkexperienceModel
  implements Serializable<JobseekerWorkexperienceModel>
{
  public jobseekerWorkExperienceId: number;

  public jobseekerId: number;

  public dateFromYear: number;

  public dateFromMonth: number;

  public dateToYear: number;

  public dateToMonth: number;

  public isCurrent: boolean;

  public employer: string;

  public positionTitle: string;

  public description: string;

  public categories: JobseekerWorkExperienceCategoryModel[];

  public attachment: JobseekerFile;

  fromObject(obj: any): JobseekerWorkexperienceModel {
    Object.assign(this, obj);

    this.categories = [];
    this.attachment = null;

    if (obj.categories && obj.categories.length && obj.categories.length > 0) {
      obj.categories.forEach((c) => {
        let t = new JobseekerWorkExperienceCategoryModel();
        t = t.fromObject(c);
        this.categories.push(t);
      });
    }

    if (obj.attachment != null) {
      let t = new JobseekerFile();
      t = t.fromObject(obj.attachment);
      this.attachment = t;
    }

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }
}
